import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  ActivityIndicator,
} from "react-native";
import React, { useState, useEffect } from "react";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import Fonts from "../../Resources/Fonts";

import db from "../Firestore/FirestoreConfig";

import {
  collection,
  query,
  where,
  getDocs,
  limit,
  doc,
  getDoc,
} from "firebase/firestore";

const allowedEmails = [
  "pol.cortess@gmail.com",
  "pol.cortes.tfn@gmail.com",
  "pol.cortes.sp@gmail.com",
  "efortapp@gmail.com",
  "synergyperformanceapp@gmail.com",
  "juan7515@efortcoach.com",
  "aleixplanasg@gmail.com",
  "wizlixgamer@gmail.com",
];

const InternalAnalytics = () => {
  const [monthlyData, setMonthlyData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const coachesRef = collection(db, "coaches");
      const q = query(
        coachesRef,
        where("trial_period_start_date", "!=", null),
        limit(600)
      );
      const querySnapshot = await getDocs(q);
      const coaches = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));

      const filteredCoaches = coaches.filter(
        (coach) => !allowedEmails.includes(coach.email)
      );

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const data = Array(12)
        .fill(0)
        .map(() => ({ joined: 0, paid: 0, paying: 0 })); // Initialize array for each month

      for (const coach of filteredCoaches) {
        const startDate = coach.trial_period_start_date.toDate();
        const month = startDate.getMonth(); // Get the month (0-11)
        if (month >= 2) {
          // Starting from March (index 2)
          data[month].joined += 1;

          // Check if the coach is in the "customers" collection
          const customerRef = doc(db, "customers", coach.id);
          const customerDoc = await getDoc(customerRef);
          if (customerDoc.exists()) {
            data[month].paid += 1;

            // Check if the coach has an active subscription
            const subscriptionsRef = collection(
              db,
              "customers",
              coach.id,
              "subscriptions"
            );
            const subscriptionsQuery = query(
              subscriptionsRef,
              where("status", "in", ["incomplete", "active", "past_due"])
            );
            const qSnapshot = await getDocs(subscriptionsQuery);
            if (!qSnapshot.empty) {
              data[month].paying += 1;
            }
          }
        }
      }

      const formattedData = months.slice(2).map((month, index) => {
        const joined = data[index + 2].joined;
        const paying = data[index + 2].paying;
        return {
          month,
          joined,
          paid: data[index + 2].paid,
          paying,
          conversionRate: joined
            ? ((paying / joined) * 100).toFixed(2) + "%"
            : "0%",
        };
      });

      setMonthlyData(formattedData);
    };

    fetchData();
  }, []);

  return (
    false && (
      <View>
        <Text>Monthly Coaches Joined and Payments</Text>
        <View style={styles.table}>
          <View style={styles.row}>
            <Text style={styles.headerCell}>Month</Text>
            <Text style={styles.headerCell}>New Coaches</Text>
            <Text style={styles.headerCell}>Stripe Customers</Text>
            <Text style={styles.headerCell}>Paying Customers</Text>
            <Text style={styles.headerCell}>Conversion Rate</Text>
          </View>
          {monthlyData.map((data, index) => (
            <View key={index} style={styles.row}>
              <Text style={styles.cell}>{data.month}</Text>
              <Text style={styles.cell}>{data.joined}</Text>
              <Text style={styles.cell}>{data.paid}</Text>
              <Text style={styles.cell}>{data.paying}</Text>
              <Text style={styles.cell}>{data.conversionRate}</Text>
            </View>
          ))}
        </View>
      </View>
    )
  );
};

const styles = StyleSheet.create({
  table: {
    marginTop: 20,
    borderWidth: 1,
    borderColor: "#ddd",
  },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#ddd",
    padding: 8,
  },
  headerCell: {
    flex: 1,
    fontWeight: "bold",
  },
  cell: {
    flex: 1,
  },
});
export default InternalAnalytics;
